import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import LinkTile from './LinkTile';

export default function LinkTiles(props) {
  const { link_tile_ids } = props;
  const data = useStaticQuery(graphql`
    query linkTiles {
      allWpLinkTile {
        edges {
          node {
            databaseId
            title
            linkTileFields {
              text
              image {
                uri
                title
                sourceUrl
              }
              link {
                url
                title
                target
              }
            }
          }
        }
      }
    }
  `);
  // filter the data of the link tiles to show the selected ones
  const filteredData = data.allWpLinkTile.edges.filter((link_tile) => {
    return link_tile_ids.includes(link_tile.node.databaseId) ? link_tile : null;
  });

  return (
    // map the filtered portals and show a callout tile for each one
    filteredData.map((linkTile) => {
      return (
        linkTile.node &&
        linkTile.node.linkTileFields &&
        linkTile.node.linkTileFields.image &&
        linkTile.node.linkTileFields.image.sourceUrl && (
          <LinkTile
            description={linkTile?.node?.linkTileFields?.text}
            key={linkTile?.node?.databaseId}
            link={linkTile?.node?.linkTileFields?.link?.url}
            target={linkTile?.node?.linkTileFields?.link?.target}
            heading={linkTile?.node?.title}
            icon={linkTile?.node?.linkTileFields?.image?.sourceUrl}
          />
        )
      );
    })
  );
}
